import React from 'react';
import ReactTooltip from 'react-tooltip';
import { defaultTemplate } from 'core/hoc';

const AddressValidationErrorsTooltip = ({ t, addressValidationErrors = [] }) => {
	return (
		<React.Fragment>
			<ReactTooltip className="surcharge" id="addressValidationErrorsTooltip">
				<div>
					{addressValidationErrors.length > 0 ? (
						addressValidationErrors.map((error) => (
							<div className="item" key={error}>
								<span>{error}</span>
							</div>
						))
					) : (
						<div className="item">
							<span>{t('No errors.')}</span>
						</div>
					)}
				</div>
			</ReactTooltip>

			<i
				data-for="addressValidationErrorsTooltip"
				data-tip=""
				className="fa fa-exclamation-circle spc--left--nano"
			></i>
		</React.Fragment>
	);
};

export default defaultTemplate(AddressValidationErrorsTooltip);
